module.exports = __webpack_public_path__ + "img/hest_dannebrog.302d956b.jpg";